import { loadStripe } from '@stripe/stripe-js/pure'

const clients = new Map()

// Only load Stripe.js for a website checkout with the server's publishable key.
export const stripePromise = publishableKey => {
  if (!/^pk_(live|test)_[A-Za-z0-9]+$/.test(publishableKey || '')) return Promise.resolve(null)
  if (!clients.has(publishableKey)) clients.set(publishableKey, loadStripe(publishableKey))
  return clients.get(publishableKey)
}
